import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import { isCurrentPath } from '@openclassrooms/routing';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import useMainNavigation from '../../hooks/useMainNavigation';
import HeaderDropDown from './HeaderDropDown';
import HeaderDropDownOverTitle from './HeaderDropDown/HeaderDropDownOverTitle';
import HeaderDropDownGroup from './HeaderDropDown/HeaderDropDownGroup';
interface Props {
  name: string;
  onClick?: () => void;
}
const noop = () => {};
const ApprenticeshipDropDownMenu = t0 => {
  const $ = _c(42);
  const {
    name,
    onClick: t1
  } = t0;
  const onClick = t1 === undefined ? noop : t1;
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  const navigationConfig = useMainNavigation();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeaderDropDown.Title title={translate("main_header.apprenticeship_dropdown.title")} subTitle={translate("main_header.training_programs.dropdown.text")} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HeaderDropDownOverTitle title={{
      content: translate("main_header.apprenticeship_dropdown.b2c.overline"),
      index: 0
    }} />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = navigationConfig.BECOME_AN_APPRENTICE.path;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translate("main_header.apprenticeship_dropdown.b2c.text");
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== navigationConfig.BECOME_AN_APPRENTICE.path) {
    t6 = isCurrentPath(navigationConfig.BECOME_AN_APPRENTICE.path);
    $[3] = navigationConfig.BECOME_AN_APPRENTICE.path;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = navigationConfig.BECOME_AN_APPRENTICE.dataEvent;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = translate("main_header.apprenticeship_dropdown.b2c.title");
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== navigationConfig.BECOME_AN_APPRENTICE.dataEvent || $[7] !== navigationConfig.BECOME_AN_APPRENTICE.path || $[8] !== onClick || $[9] !== t6) {
    t9 = <HeaderDropDown.Item onClick={onClick} path={t4} subTitle={t5} isActive={t6} data-event={t7}>{t8}</HeaderDropDown.Item>;
    $[6] = navigationConfig.BECOME_AN_APPRENTICE.dataEvent;
    $[7] = navigationConfig.BECOME_AN_APPRENTICE.path;
    $[8] = onClick;
    $[9] = t6;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== navigationConfig.CONSULT_JOB_OFFERS.dataEvent || $[12] !== navigationConfig.CONSULT_JOB_OFFERS.path || $[13] !== navigationConfig.CONSULT_JOB_OFFERS.shouldBeDisplayed || $[14] !== onClick) {
    t10 = navigationConfig.CONSULT_JOB_OFFERS.shouldBeDisplayed && <HeaderDropDown.Item onClick={onClick} path={navigationConfig.CONSULT_JOB_OFFERS.path} subTitle={translate("main_header.apprenticeship_dropdown.b2c_job.text")} isActive={isCurrentPath(navigationConfig.CONSULT_JOB_OFFERS.path)} data-event={navigationConfig.CONSULT_JOB_OFFERS.dataEvent}>{translate("main_header.apprenticeship_dropdown.b2c_job.title")}</HeaderDropDown.Item>;
    $[11] = navigationConfig.CONSULT_JOB_OFFERS.dataEvent;
    $[12] = navigationConfig.CONSULT_JOB_OFFERS.path;
    $[13] = navigationConfig.CONSULT_JOB_OFFERS.shouldBeDisplayed;
    $[14] = onClick;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <HeaderDropDownGroup>{t3}{t9}{t10}</HeaderDropDownGroup>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <HeaderDropDownOverTitle title={{
      content: translate("main_header.apprenticeship_dropdown.business.overline"),
      index: 1
    }} />;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = navigationConfig.RECRUIT_APPRENTICES.path;
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = translate("main_header.apprenticeship_dropdown.business.text");
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== navigationConfig.RECRUIT_APPRENTICES.path) {
    t15 = isCurrentPath(navigationConfig.RECRUIT_APPRENTICES.path);
    $[21] = navigationConfig.RECRUIT_APPRENTICES.path;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const t16 = navigationConfig.RECRUIT_APPRENTICES.dataEvent;
  let t17;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = translate("main_header.apprenticeship_dropdown.business.title");
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== navigationConfig.RECRUIT_APPRENTICES.dataEvent || $[25] !== navigationConfig.RECRUIT_APPRENTICES.path || $[26] !== onClick || $[27] !== t15) {
    t18 = <HeaderDropDown.Item onClick={onClick} path={t13} subTitle={t14} isActive={t15} data-event={t16}>{t17}</HeaderDropDown.Item>;
    $[24] = navigationConfig.RECRUIT_APPRENTICES.dataEvent;
    $[25] = navigationConfig.RECRUIT_APPRENTICES.path;
    $[26] = onClick;
    $[27] = t15;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== getLocalisationConfig || $[30] !== navigationConfig.FINALIZE_APPRENTICESHIP || $[31] !== onClick) {
    t19 = getLocalisationConfig("apprenticeship.hasTalentPool") && <HeaderDropDown.Item onClick={onClick} path={navigationConfig.FINALIZE_APPRENTICESHIP.path} subTitle={translate("main_header.apprenticeship_dropdown.business_finalize.text")} isActive={isCurrentPath(navigationConfig.FINALIZE_APPRENTICESHIP.path)} data-event={navigationConfig.FINALIZE_APPRENTICESHIP.dataEvent}>{translate("main_header.apprenticeship_dropdown.business_finalize.title")}</HeaderDropDown.Item>;
    $[29] = getLocalisationConfig;
    $[30] = navigationConfig.FINALIZE_APPRENTICESHIP;
    $[31] = onClick;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t18 || $[34] !== t19) {
    t20 = <HeaderDropDownGroup>{t12}{t18}{t19}</HeaderDropDownGroup>;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t11 || $[37] !== t20) {
    t21 = [t11, t20];
    $[36] = t11;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== name || $[40] !== t21) {
    t22 = <HeaderDropDown name={name} title={t2} items={t21} />;
    $[39] = name;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  return t22;
};
export default ApprenticeshipDropDownMenu;